import { useLocation, useNavigate } from 'react-router-dom'
import PersonalAssistantCard from './PersonalAssistantCard'
import { useAgentService } from './agentService'
import { useEffect } from 'react'
import AgentWizard from './AgentWizard'
import { setBreadCrumbMapper } from '../../../../_redux/actions/breadCrumbMapperAction'
import { defaultBreadcrumbs } from '../../../../@core/layouts/new-VerticalLayout'
import { useDispatch } from 'react-redux'
import { useFeatureGate } from '../../../../_hooks/useFeatureGate'

const ManageAgents = () => {
  const location = useLocation()
  const isEdit = location.pathname.includes('edit-agent')
  const { getAgentsListByUser } = useAgentService()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { value: centrali3_0 } = useFeatureGate('centrali3_0', false)

  useEffect(() => {
    // Only fetch when on the main manage-agents route
    if (location.pathname === '/manage-agents' && centrali3_0) {
      const fetchAssistants = async () => {
        await getAgentsListByUser()
      }
      fetchAssistants()
    }
  }, [location.pathname, centrali3_0])

  useEffect(() => {
    // Set breadcrumbs based on route and state
    const breadcrumbsMapper = [
      {
        ...defaultBreadcrumbs,
        onClick: () => navigate('/')
      },
      ...(location?.state?.fromAli === true
        ? [
            {
              label: 'Ali',
              onClick: () => navigate('/chat')
            }
          ]
        : []),
      {
        label: 'Agents',
        ...(location.pathname !== '/manage-agents' && { onClick: () => navigate('/manage-agents') })
      }
    ]

    if (location.pathname !== '/manage-agents') {
      breadcrumbsMapper.push({
        label: location.pathname.includes('edit') ? 'Edit Agent' : 'Add Agent',
        onClick: () => {}
      })
    }

    dispatch(setBreadCrumbMapper(breadcrumbsMapper))
  }, [location.pathname, location?.state])

  const manageAgentCard = () => {
    return (
      <div className="w-full mt-1 px-2">
        <div className="w-full text-left px-50">
          <h1 className="text-3xl font-bold mb-50 text-dark">
            {isEdit ? 'Edit agent' : 'Add agent'}
          </h1>
          <p className="text-gray-800 mb-[8px]">
            {isEdit
              ? "Edit your agent's defined identity."
              : 'Add an agent with a defined identity.'}
            {/* , added skills, and connected data sources. */}
          </p>
        </div>

        <div className="mx-auto h-full flex-justify-center">
          <AgentWizard />
        </div>
      </div>
    )
  }

  return (
    <div
      className="flex flex-col gap-1 pt-0 align-items-center overflow-auto w-full"
      data-testid="personal-assistant">
      {location.pathname === '/manage-agents' ? <PersonalAssistantCard /> : manageAgentCard()}
    </div>
  )
}

export default ManageAgents
